import { view } from "./lib/vvm";
import { QR } from "./screens/QR";
import { Screens } from "./stores/navigation";
import { Main } from "./screens/Main/Main";
import { BoxPage } from "./screens/BoxPage/BoxPage";
import { type Box } from "./stores/Box";
import type { Product } from "./stores/Product";
import styles from "./App.module.css";
import { ProductPage } from "./screens/ProductPage/ProductPage";
import { AddProductPage } from "./screens/AddProductPage/AddProductPage";
import type { AddProductPageViewProps } from "./screens/AddProductPage/AddProductPageViewModel";
import { AddBoxPage } from "./screens/AddBoxPage/AddBoxPage";
import type { AddBoxPageViewProps } from "./screens/AddBoxPage/AddBoxPageViewModel";
import { EditBoxPage } from "./screens/EditBoxPage/EditBoxPage";
import { EditProductPage } from "./screens/EditProductPage/EditProductPage";
import { QRManagementPage } from "./screens/QRManagementPage/QRManagementPage";
import { JournalPage } from "./screens/JournalPage/JournalPage";
import { Login } from "./screens/Login/Login";
import { AppViewModel } from "./AppViewModel";
import { setupMvvmDi } from "./di/setupMvvmDi";
import { ProductsListPage } from "./screens/ProductsListPage/ProductsListPage";
import type { ProductsListPageViewProps } from "./screens/ProductsListPage/ProductsListPageViewModel";
import { BoxesListPage } from "./screens/BoxesListPage/BoxesListPage";
import type { BoxesListPageViewProps } from "./screens/BoxesListPage/BoxesListPageViewModel";
import { UsersManagementPage } from "./screens/UsersManagementPage/UsersManagementPage";
import { DeletedEntitiesPage } from "./screens/DeletedEntitiesPage/DeletedEntitiesPage";
import { AccountPage } from "./screens/AccountPage/AccountPage";
import { SettingsPage } from "./screens/SettingsPage/SettingsPage";

setupMvvmDi();

const App = view(AppViewModel)(({
  viewModel: {
    screen,
    props,
    accessDeniedMessage,
    hasAccessDeniedMessage,
    dismissAccessDenied,
  },
}) => {
  return (
    <div className={styles.root}>
      {hasAccessDeniedMessage && accessDeniedMessage ? (
        <div className={styles.accessDeniedBanner} role="alert">
          <span>{accessDeniedMessage}</span>
          <button
            type="button"
            className={styles.dismissAccessDeniedBanner}
            onClick={dismissAccessDenied}
            aria-label="Закрыть сообщение о доступе"
          >
            x
          </button>
        </div>
      ) : null}
      {screen === Screens.Login && <Login />}
      {screen === Screens.Main && <Main />}
      {screen === Screens.QR && <QR />}
      {screen === Screens.QRManagement && <QRManagementPage />}
      {screen === Screens.Journal && <JournalPage />}
      {screen === Screens.ProductsList && (
        <ProductsListPage {...(props as ProductsListPageViewProps)} />
      )}
      {screen === Screens.BoxesList && (
        <BoxesListPage {...(props as BoxesListPageViewProps)} />
      )}
      {screen === Screens.UsersManagement && <UsersManagementPage />}
      {screen === Screens.DeletedEntities && <DeletedEntitiesPage />}
      {screen === Screens.Account && <AccountPage />}
      {screen === Screens.Settings && <SettingsPage />}
      {screen === Screens.Box && <BoxPage box={props as Box} />}
      {screen === Screens.EditBox && <EditBoxPage box={props as Box} />}
      {screen === Screens.Product && <ProductPage product={props as Product} />}
      {screen === Screens.EditProduct && (
        <EditProductPage product={props as Product} />
      )}
      {screen === Screens.AddProduct && (
        <AddProductPage {...((props as AddProductPageViewProps) || {})} />
      )}
      {screen === Screens.AddBox && (
        <AddBoxPage {...((props as AddBoxPageViewProps) || {})} />
      )}
    </div>
  );
});

export default App;
